import React from 'react';
import { useNavigate } from 'react-router-dom';
import Services from '../services/Services';
import { logEvent } from '../utils/analyticsManager'; // GA4 Import

export default function PartnerCircle({ image, name, token, companyID, company, sessionID }) {
    const navigate = useNavigate();

    const handleCompanyClick = () => {
        // GA4: Marka tıklama eventi
        logEvent('Partner', 'Markaya Tıklandı', name);

        // Mevcut Backend Tracking
        if (sessionID) {
            Services.AddAnalyticsTracking(
                token,
                sessionID,
                'partner_brand_click',
                name,
                'click'
            ).catch((err) => console.log('Analytics tracking error:', err));
        }

        navigate(`/${token}/${companyID}`, { state: {company} });
    };

    return (
        <div
            onClick={handleCompanyClick}
            style={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                cursor: 'pointer',
                textAlign: 'center'
            }}
        >
            <div
                key={1}
                style={{
                    backgroundColor: 'white',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                }}
            >
                <img
                    src={image}
                    alt={name}
                    style={{
                        width: '65%',
                        height: '65%',
                        objectFit: 'contain'
                    }}
                />
            </div>
            <p
                style={{
                    color: '#494D59',
                    fontSize: '12px',
                    fontWeight: '500',
                    maxWidth: '60px',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                    marginTop: '4px',
                    whiteSpace: 'normal'
                }}
            >
                {name}
            </p>
        </div>
    );
}